class ProductStockEditingService extends BaseService
	@register()
	@inject	'$q',
		'parseBool'
		'StockEventsRepository'
		'StockValueRepository'
		'BACKEND_STOCK_EVENT_ENTITY_TYPE'

	saveStockEvents: (ProductController) ->
		@controller = ProductController

		stockEvents = @getStockEventsForSaving()

		stockEventsBatch = []

		for stockEvent in stockEvents
			stockEventsBatch.push(
				@StockEventsRepository.save(stockEvent, true)
			)

		if stockEventsBatch.length > 0
			return @StockEventsRepository.all(stockEventsBatch)

		return @$q.when(false)

	getStockEventsForSaving: ->
		stockEvents = []

		if @controller.product.product_variants?.length
			angular.forEach @controller.product.product_variants, (variant) =>
				angular.forEach variant.stock_values, (variantStock) =>
					if parseFloat(variantStock.delta_quantity || 0) != 0 || variantStock.isNew
						@addStockEvent(stockEvents, variantStock)

			##
			# If it is not new product and adding product_variants then remove product stock
			##
			angular.forEach @controller.product.stock_values, (productStock) =>
				@controller.stockValuesToRemove.push angular.copy(productStock)
				productStock.quantity = 0
				productStock.delta_quantity = 0
		else
			angular.forEach @controller.product.stock_values, (productStock) =>
				if parseFloat(productStock.delta_quantity || 0) != 0 || productStock.isNew
					@addStockEvent(stockEvents, productStock)

		if @controller.stockValuesToRemove.length
			stockValuesToRemove = _.chain(@controller.stockValuesToRemove)
				.flatten @controller.stockValuesToRemove, true
				.filter (value) => !value.isNew && parseFloat(value.quantity || 0) != 0
				.value()

			angular.forEach stockValuesToRemove, (stockValue) =>
				stockValue.delta_quantity = parseFloat(stockValue.quantity || 0) * -1
				@addStockEvent(stockEvents, stockValue)

		return stockEvents

	addStockEvent: (stockEvents, stock) ->
		if parseFloat(stock.delta_quantity || 0) >= 0
			entityType = @BACKEND_STOCK_EVENT_ENTITY_TYPE.ADD
		else
			entityType = @BACKEND_STOCK_EVENT_ENTITY_TYPE.REMOVE

		event = _.findWhere(
			stockEvents,
			{
				entity_type: entityType,
				stock_location_id: stock.stock_location_id,
				reason_code_id: stock.reason_code_id
			}
		)

		stockEventLine = {
			delta_quantity: parseFloat(stock.delta_quantity || 0).toFixed(3)
			product_id: stock.product_id
			product_variant_id: stock.product_variant_id
			sku: if stock.sku? then stock.sku else null
			name: if stock.name? then stock.name else null
		}

		if angular.isDefined(event)
			event.stock_event_lines.push stockEventLine
		else
			stockEventReferenceIdLength = 128
			stockEvents.push({
				reason_code_id: stock.reason_code_id
				reference_id: (entityType + ' - ' + @controller.product.name).substring(0, stockEventReferenceIdLength)
				stock_location_id: stock.stock_location_id
				entity_type: entityType
				stock_event_lines: [
					stockEventLine
				]
			})

	saveStockValues: (ProductController) ->
		@controller = ProductController

		return @reloadStockValues()
			.then (existingStockValues) =>
				stockValuesBatch = [];

				stockValuesBatch.push(@getStockValueRequests(existingStockValues, @controller.product)...)

				for variant in @controller.product.product_variants
					stockValuesBatch.push(@getStockValueRequests(existingStockValues, variant)...)

				if stockValuesBatch.length > 0
					return @StockValueRepository.all(stockValuesBatch)

				return @$q.when(false)

	getStockValueRequests: (existingStockValues, product) ->
		stockValuesRequests = []
		isForNewProduct = product.is_new || @controller.mainCrud.isNewEntity

		for stockValue in product.stock_values
			request = @getStockValueRequest(
				existingStockValues,
				stockValue,
				isForNewProduct,
			)

			if request?
				stockValuesRequests.push(request)

		return stockValuesRequests

	getStockValueRequest: (existingStockValues, stockValue, isForNewProduct) ->
		if !isForNewProduct && stockValue.isNew
			return @getCreateStockValueRequest(stockValue)

		existingStockValue = _.find(
			existingStockValues,
			{
				product_id: stockValue.product_id,
				product_variant_id: stockValue.product_variant_id,
				stock_location_id: stockValue.stock_location_id
			}
		)

		if !existingStockValue || !@hasStockValueChanged(stockValue, existingStockValue)
			return null

		return @getUpdateStockValueRequest(existingStockValue.id, stockValue)

	getCreateStockValueRequest: (stockValue) ->
		stockValueClone = _.clone(stockValue)
		stockValueClone.quantity = parseFloat(stockValue.delta_quantity || 0)
		delete stockValueClone.delta_quantity
		delete stockValueClone.isNew
		delete stockValueClone.possibleReasonCodes
		delete stockValueClone.reason_code_id
		delete stockValueClone.stock_location_name

		return @StockValueRepository.post('', stockValueClone)

	getUpdateStockValueRequest: (id, stockValue) ->
		return @StockValueRepository.patch(
			id,
			{
				min_quantity: stockValue.min_quantity,
				shelf: stockValue.shelf,
				is_included_in_ordering_suggestion_report: stockValue.is_included_in_ordering_suggestion_report,
			}
		)

	hasStockValueChanged: (current, existing) ->
		current_included = @parseBool(current.is_included_in_ordering_suggestion_report)
		existing_included = @parseBool(existing.is_included_in_ordering_suggestion_report)
		return parseFloat(current.min_quantity || 0) != parseFloat(existing.min_quantity || 0) ||
			current.shelf != existing.shelf ||
			current_included != existing_included

	reloadStockValues: ->
		query = @StockValueRepository.createQuery()
		query.criteria 'product_id', '=', @controller.product.id

		return @StockValueRepository.getEntities query
